<mod-view-user-diary [inputData]="sharedData()"></mod-view-user-diary>
